module.exports = __webpack_public_path__ + "static/media/OFL.2c309aad.txt";